var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenipak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 16,
    viewBox: "0 0 80 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_251)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_251",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V16H80V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9362 8.08647V13.0863H34.1515V8.66529C34.1515 7.27489 33.6891 6.6419 32.6438 6.6419C31.5643 6.6419 30.9993 7.3476 30.9993 8.71842V13.0866H27.2325V4.06131H29.9223L30.8974 5.90261C31.5643 4.51222 32.7465 3.79004 34.3567 3.79004C36.7038 3.79004 37.9362 5.27108 37.9362 8.08647Z",
    fill: "#9339F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4744 0.0280762H43.3451V2.94144H39.4744V0.0280762ZM39.5262 4.06056H43.2945V13.087H39.5262V4.06056Z",
    fill: "#9339F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0104 3.79028C50.622 3.79028 49.4263 4.33202 48.7063 5.41266V5.41916L48.7044 5.41488L47.9863 4.06156H45.0398V16H48.8066V11.9864C49.5948 12.8895 50.5529 13.357 51.8902 13.357C54.4587 13.357 56.1893 11.4634 56.1893 8.50137C56.1898 5.66946 54.5273 3.79028 52.0104 3.79028ZM50.5373 10.8659C49.44 10.8659 48.7384 10.0188 48.7384 8.71765V8.39342C48.7384 7.00386 49.4054 6.26274 50.5193 6.26274C51.6506 6.26274 52.2845 7.07572 52.2845 8.50156C52.2845 9.96363 51.6326 10.8659 50.5373 10.8659Z",
    fill: "#9339F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2845 3.78613C59.2672 3.78613 57.2308 5.01684 56.9936 7.1455H60.8251C60.9098 6.44267 61.4102 6.06122 62.2623 6.06122C63.0519 6.06122 63.5366 6.3934 63.5366 7.09684V7.43552L60.5032 7.74531C59.1125 7.90639 58.222 8.17317 57.6393 8.62653C57.0405 9.0799 56.7489 9.72813 56.7489 10.5782C56.7489 12.2935 58.0696 13.3531 60.2646 13.3531C61.902 13.3531 63.2332 12.7134 63.6999 11.6922V11.6835L63.7018 11.6878C63.7042 11.6855 63.7042 11.6813 63.7061 11.679V11.6963L64.4417 13.0859H67.3378V7.7286C67.3378 5.05679 65.8102 3.78613 62.2845 3.78613ZM63.6209 9.67966C63.6209 10.5464 62.8833 11.1352 61.7861 11.1352C61.0485 11.1352 60.588 10.7957 60.588 10.254C60.588 9.72813 61.0178 9.4214 61.9773 9.275L63.6209 9.0799V9.67966Z",
    fill: "#9339F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7469 13.0872V0H72.5145V7.22061L75.4097 4.06059H79.9313L76.8014 7.21181L80 13.0872H75.8376L73.8726 9.57045L72.5145 10.8665V13.0872H68.7469Z",
    fill: "#9339F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0283203H4.24502L10.4073 11.3372V0.0283203H14.2375V13.0872H7.16137L0 0.0283203Z",
    fill: "#9339F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1584 8.64125C26.1584 5.6228 24.3617 3.76256 21.1034 3.66012C21.0091 3.65646 20.9107 3.65503 20.8123 3.65503C20.5123 3.65503 20.213 3.67173 19.9378 3.71165C17.1418 4.01042 15.383 5.80101 15.383 8.47875C15.383 11.4567 17.9925 13.2212 21.005 13.2212C22.3146 13.2212 23.5546 13.0558 24.977 11.9063C25.1084 11.8012 25.2427 11.686 25.3776 11.5618L24.0392 9.25612C23.9449 9.37136 23.8396 9.49339 23.7214 9.6172C23.2108 10.1482 22.462 10.6884 21.3507 10.6884C20.1527 10.6884 19.0854 9.93348 18.9471 9.03494H26.1587L26.1584 8.64125ZM18.9466 7.13927C19.0313 6.16741 19.6686 5.75113 20.7598 5.75113C21.8429 5.75113 22.4947 6.29 22.4947 7.13927H18.9466Z",
    fill: "#9339F2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenipak);
export default __webpack_public_path__ + "static/media/venipak.1058f8fb4b9127ab5dcb87b65db31d29.svg";
export { ForwardRef as ReactComponent };